import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function MetaTags({
  title,
  description,
  image,
  url,
  type = 'website'
}) {
  const location = useLocation();
  const baseUrl = 'https://deedslab.com';
  const fullUrl = url || `${baseUrl}${location.pathname}`;
  const fullImage = image || `${baseUrl}/social-share-experiments.png`;

  useEffect(() => {
    // Update document title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (property, content) => {
      let element = document.querySelector(`meta[property="${property}"]`) ||
                   document.querySelector(`meta[name="${property}"]`);

      if (element) {
        element.setAttribute('content', content);
      } else {
        element = document.createElement('meta');
        element.setAttribute(property.startsWith('og:') || property.startsWith('twitter:') ? 'property' : 'name', property);
        element.setAttribute('content', content);
        document.getElementsByTagName('head')[0].appendChild(element);
      }
    };

    // Primary meta tags
    updateMetaTag('description', description);
    updateMetaTag('title', title);

    // Open Graph tags
    updateMetaTag('og:type', type);
    updateMetaTag('og:url', fullUrl);
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:image', fullImage);
    updateMetaTag('og:image:width', '1200');
    updateMetaTag('og:image:height', '630');
    updateMetaTag('og:image:alt', title);
    updateMetaTag('og:site_name', 'deedslab.com');
    updateMetaTag('og:locale', 'en_US');

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:url', fullUrl);
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', fullImage);
    updateMetaTag('twitter:image:alt', title);

    // Canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', fullUrl);
    } else {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      canonicalLink.setAttribute('href', fullUrl);
      document.getElementsByTagName('head')[0].appendChild(canonicalLink);
    }

  }, [title, description, image, url, type, location.pathname, fullUrl, fullImage]);

  return null; // This component doesn't render anything
}
